<div class="flex-column gap-4">
	<span>
		An informational banner that provides users with contextual information about incoming emails and helps to identify suspicious elements.<br/>
	</span>

	<!--Page loader-->
	<div class="flex-row justify-content-center f-1-0" *ngIf="getSecurityAwarenessDataInProcess">
		<loader height="100" width="100" style="opacity: 0.8;"></loader>
	</div>

	<!--Smart Banner -->
	<div class="flex-column gap-2" style="max-width: 1350px;" *ngIf="!getSecurityAwarenessDataInProcess">
		<div class="flex-row gap-5">
			<div class="list-group list-group-flush settings-list-container spread-evenly f-1-0">
				<div class="list-group-item settings-list-item">
					<div class="title-section-container flex-column gap-2" style="flex: 2.5 0;">
						<b class="flex-row align-items-center gap-2">
							<span>Status</span>
							<i class="fa fa-circle" style="font-size: 0.7em;"
							   [ngClass]="{'text-success' : planInfo?.security_awareness?.smart_banner.enable_status !== dic.CONSTANTS.groupSelection.disabled,
											   'text-danger' : planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}"></i>
						</b>
						<span class="lh-base" style="font-size: 0.9em;">Smart Banners can be enabled for all mailboxes, or for specific mailboxes.</span>
					</div>
					<div class="content-container flex-column gap-3 f-1-0">
						<div class="flex-row align-items-center gap-2" style="flex-wrap: wrap; min-width: 250px;">
							<label class="radio-container m-0">
								Enabled for <b>all</b> mailboxes except:
								<input type="radio" name="smartBannerEnableStatusGroup" [value]="dic.CONSTANTS.groupSelection.all"
									   [(ngModel)]="smartBannerStatus"
									   [checked]="smartBannerStatus === dic.CONSTANTS.groupSelection.all">
								<span class="checkmark"></span>
							</label>
							<app-dropdown-c class="f-1-0 w-ellipsis" style="flex-basis: 250px; max-width: 250px;"
											[items]="excludedMailboxes" itemDisplayKey="email"
											[text]="_.map(_.filter(excludedMailboxes, 'selected'), 'email').join(', ')|| 'Select mailboxes (Optional)'"
											[isDisabled]="smartBannerStatus !== dic.CONSTANTS.groupSelection.all"
											[isMultipleSelection]="true"
											[enableSearch]="true">
							</app-dropdown-c>
						</div>

						<div class="flex-row align-items-center gap-2" style="flex-wrap: wrap; min-width: 250px;">
							<label class="radio-container m-0">
								<span>Enabled for <b>specific</b> mailboxes</span>
								<input type="radio" name="smartBannerEnableStatusGroup" [value]="dic.CONSTANTS.groupSelection.specific"
									   [(ngModel)]="smartBannerStatus"
									   [checked]="smartBannerStatus === dic.CONSTANTS.groupSelection.specific">
								<span class="checkmark"></span>
							</label>
							<app-dropdown-c class="f-1-0 w-ellipsis" style="flex-basis: 250px; max-width: 250px;"
											[items]="mailboxes" itemDisplayKey="email"
											[isDisabled]="smartBannerStatus !== dic.CONSTANTS.groupSelection.specific"
											[isMultipleSelection]="true"
											[enableSearch]="true">
							</app-dropdown-c>
						</div>

						<label class="radio-container m-0">
							Disabled
							<input type="radio" name="smartBannerEnableStatusGroup" [value]="dic.CONSTANTS.groupSelection.disabled"
								   [(ngModel)]="smartBannerStatus"
								   [checked]="smartBannerStatus === dic.CONSTANTS.groupSelection.disabled">
							<span class="checkmark"></span>
						</label>

						<btn-c class="mt-2"
							   [isDisabled]="updatePolicyInProcess"
							   (action)="updateSecurityAwarenessEnable();">
							Update
						</btn-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item"
					 [ngClass]="{'disabled' : planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}">
					<div class="title-section-container flex-column gap-2">
						<b>Skip for internal emails</b>
						<span class="lh-base" style="font-size: 0.9em;">The Smart Banner will not be added to internal emails.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="skip_internal"
										 [isDisabled]="planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled"
										 [(model)]="planInfo?.security_awareness?.smart_banner.skip_internal"
										 (onChange)="updateSecurityAwarenessSkipInternal()"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item"
					 [ngClass]="{'disabled' : planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}">
					<div class="title-section-container flex-column gap-2">
						<b>Skip for contact emails</b>
						<span class="lh-base" style="font-size: 0.9em;">The Smart Banner will not be added to emails from contacts.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="skip_contact"
										 [isDisabled]="planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled"
										 [(model)]="planInfo?.security_awareness?.smart_banner.skip_contact"
										 (onChange)="updateSecurityAwarenessSkipContact()"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item"
					 [ngClass]="{'disabled' : planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}">
					<div class="title-section-container flex-column gap-2">
						<b>Skip for allowlisted senders</b>
						<span class="lh-base" style="font-size: 0.9em;">The Smart Banner will not be added when the sender is allowlisted (email, domain, IP, MTA, or other sender identity).</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="skip_allowlist"
										 [isDisabled]="planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled"
										 [(model)]="planInfo?.security_awareness?.smart_banner.skip_allowlist"
										 (onChange)="updateSecurityAwarenessSkipAllowlist()"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item"
					 [ngClass]="{'disabled' : planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}">
					<div class="title-section-container flex-column gap-2">
						<b>Allow report</b>
						<span class="lh-base" style="font-size: 0.9em;">Allow users to report emails as trusted or as dangerous directly from the Smart Banner.<br/>
								When reporting is enabled, a quarantine record will be created for all emails containing a Smart Banner.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="allow_reporting" *ngIf="planInfo?.security_awareness?.smart_banner"
										 [isDisabled]="planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled"
										 [(model)]="planInfo?.security_awareness?.smart_banner.allow_reporting"
										 (onChange)="updateSecurityAwarenessAllowReport()"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item"
					 [ngClass]="{'disabled' : planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}">
					<div class="title-section-container flex-column gap-2">
						<b>Add "External" note</b>
						<span class="lh-base" style="font-size: 0.9em;">The Smart Banner will notify when an email is received from an external sender.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="add_external_note"
										 [isDisabled]="planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled"
										 [(model)]="planInfo?.security_awareness?.smart_banner.add_external_note"
										 (onChange)="updateSecurityAwarenessExternal()"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item"
					 [ngClass]="{'disabled' : planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}">
					<div class="title-section-container flex-column gap-2">
						<b>Add positive feedback</b>
						<span class="lh-base" style="font-size: 0.9em;">The Smart Banner will also explain what makes certain emails more secure or trustworthy.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="add_positive_feedback"
										 [isDisabled]="planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled"
										 [(model)]="planInfo?.security_awareness?.smart_banner.add_positive_feedback"
										 (onChange)="updateSecurityAwarenessPositiveFeedback()"></toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item"
					 [ngClass]="{'disabled' : planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}">
					<div class="title-section-container flex-column gap-2">
						<b>Show footer</b>
						<span class="lh-base" style="font-size: 0.9em;">Adds a "Protected by Trustifi" footer below the Smart Banner.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="show_learn_more"
										 [isDisabled]="planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled"
										 [(model)]="planInfo?.security_awareness?.smart_banner.show_learn_more"
										 (onChange)="updateSecurityAwarenessLearnMore()"></toggle-switch-c>
					</div>
				</div>
			</div>

			<div class="p-3 px-4 border flex-column gap-3" style="width:480px;max-width:100%;flex:0 0 auto;box-sizing:border-box;">
				<div class="flex-column gap-2">
					<span class="fw-500">Preview banner</span>
					<span class="lh-base" style="font-size: 0.9em;">Choose a severity to see how the banner looks with your current settings.</span>
					<div class="simple-tab-row w100 flxRow">
						<div class="tab-header" *ngFor="let tab of previewSeverityTabs"
							 [ngClass]="{'chosen': previewSeverityTab === tab.id && !isPreviewTabDisabled(tab.id), 'disabled': isPreviewTabDisabled(tab.id)}"
							 [attr.title]="getPreviewTabDisabledReason(tab.id)"
							 [style.opacity]="isPreviewTabDisabled(tab.id) ? '0.45' : null"
							 [style.cursor]="isPreviewTabDisabled(tab.id) ? 'not-allowed' : null"
							 [style.pointer-events]="isPreviewTabDisabled(tab.id) ? 'none' : null"
							 (click)="selectPreviewSeverity(tab.id)">
							<span class="hvr-opacity">{{tab.label}}</span>
						</div>
					</div>
				</div>

				<div class="flex-column w100"
					 [ngClass]="{'opacity-50': planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled}">
					<ng-container *ngTemplateOutlet="bannerTemplate"></ng-container>
				</div>
				<span class="text-danger animated fadeIn" style="font-size: 0.9em;"
					  *ngIf="planInfo?.security_awareness?.smart_banner.enable_status === dic.CONSTANTS.groupSelection.disabled">
					Smart Banners are currently disabled.
				</span>
			</div>
		</div>
	</div>

</div>

<!--banner template (from BE)-->
<ng-template #bannerTemplate>
	<div id="trustifiSmartBanner_0" class="trustifiSmartBanner_0" style="width:100%;box-sizing:border-box;">
		<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" id="trustifiSmartBanner_1" class="trustifiSmartBanner_1"
			   style="width:100%;table-layout:fixed;border-collapse:collapse;margin:0 0 12px 0;">
			<tr>
				<td id="trustifiSmartBanner_2" class="trustifiSmartBanner_2" style="padding:0;font-family:Arial,Helvetica,sans-serif;">
					<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" id="trustifiSmartBanner_4" class="trustifiSmartBanner_4"
						   [ngStyle]="{'background': previewBanner.bg, 'border-top': '1px solid ' + previewBanner.border, 'border-right': '1px solid ' + previewBanner.border, 'border-bottom': '1px solid ' + previewBanner.border, 'border-left': '4px solid ' + previewBanner.stamp}"
						   style="width:100%;table-layout:fixed;border-collapse:separate;border-radius:8px;">
						<tr>
							<td valign="top" style="padding:8px 8px 2px 10px;vertical-align:top;font-family:Arial,Helvetica,sans-serif;font-size:13px;font-weight:700;line-height:1.3;color:#1f2328;">
								{{previewBanner.title}}
							</td>
							<td width="1%" valign="top" align="right" style="padding:0;vertical-align:top;text-align:right;line-height:12px;font-size:10px;">
								<table role="presentation" border="0" cellpadding="0" cellspacing="0" align="right" id="trustifiSmartBanner_3" class="trustifiSmartBanner_3" style="border-collapse:separate;">
									<tr>
										<td [ngStyle]="{'background': previewBanner.stamp}"
											style="color:#ffffff;padding:4px 9px;border-radius:0 8px 0 8px;font-family:Arial,Helvetica,sans-serif;font-size:10px;font-weight:700;line-height:12px;white-space:nowrap;">
											{{previewBanner.severityLabel}}
										</td>
									</tr>
								</table>
							</td>
						</tr>
						<tr>
							<td colspan="2"
								[ngStyle]="{'padding': previewBanner.showFooter ? '2px 10px 4px 10px' : '2px 10px 8px 10px'}"
								style="font-family:Arial,Helvetica,sans-serif;font-size:12px;font-weight:400;line-height:1.45;color:#424a53;word-break:break-word;">
								{{previewBanner.phrase}}
							</td>
						</tr>
						<tr *ngIf="previewBanner.showFooter">
							<td colspan="2" style="padding:2px 10px 6px 10px;">
								<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%"
									   style="width:100%;border-collapse:collapse;">
									<tr>
										<td align="left" valign="middle" style="padding:2px 8px 2px 0;vertical-align:middle;line-height:24px;font-size:12px;">
											<span *ngIf="previewBanner.showReporting" id="trustifiSmartBanner_5" class="trustifiSmartBanner_5">
												<a href="javascript:void(0)"
												   [ngStyle]="{'background': previewBanner.reportFill, 'color': previewBanner.reportText, 'border': '1px solid ' + previewBanner.reportStroke}"
												   style="cursor:default;display:inline-block;text-decoration:none;font-family:Arial,Helvetica,sans-serif;font-size:12px;font-weight:600;line-height:14px;padding:4px 10px;border-radius:4px;margin:0 6px 0 0;vertical-align:middle;">Report</a>
												<a href="javascript:void(0)"
												   [ngStyle]="{'background': previewBanner.trustFill, 'color': previewBanner.trustText, 'border': '1px solid ' + previewBanner.trustStroke}"
												   style="cursor:default;display:inline-block;text-decoration:none;font-family:Arial,Helvetica,sans-serif;font-size:12px;font-weight:600;line-height:14px;padding:4px 10px;border-radius:4px;vertical-align:middle;">Trust</a>
											</span>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</td>
			</tr>
			<tr *ngIf="previewBanner.showBranding">
				<td id="trustifiSmartBanner_6" class="trustifiSmartBanner_6" style="padding:4px 0 0 0;font-family:Arial,Helvetica,sans-serif;">
					<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%" id="trustifiSmartBanner_7" class="trustifiSmartBanner_7"
						   style="width:100%;border-collapse:collapse;margin:4px 0 0 0;">
						<tr>
							<td align="right" style="padding:0;text-align:right;">
								<table role="presentation" border="0" cellpadding="0" cellspacing="0" align="right" style="border-collapse:collapse;margin:0 0 0 auto;">
									<tr>
										<td align="right" valign="middle" style="padding:0 5px 0 0;vertical-align:middle;line-height:0;font-size:0;">
											<img src="images/logo-icon.svg" width="12" height="12" alt=""
												 style="display:block;border:0;width:12px;height:12px;">
										</td>
										<td align="right" valign="middle"
											style="padding:0;vertical-align:middle;font-family:Arial,Helvetica,sans-serif;font-size:10px;line-height:1.2;color:#8c959f;white-space:nowrap;text-align:right;">
											Protected by <a href="https://trustifi.com/" target="_blank" rel="noopener noreferrer" style="font-weight:700;color:#486db5;text-decoration:none;">Trustifi</a>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</td>
			</tr>
		</table>
		<br style="clear: both;">
	</div>
</ng-template>
<!---->
